import type {
  IXShareSelection,
  IXShareSummary,
} from "~/feature/chart/components/XShareDialog/types";
import type { IMarket, IOutcomeConsensus } from "~/types/event";
import { getMarketRowText } from "~/utils/getMarketRowText";
import { uniquePlatforms } from "~/utils/uniquePlatforms";

const QUESTION_ORDER = ["question", "marketTitle", "eventTitle"] as const;

const getQuestion = (market: IMarket, eventTitle: string): string =>
  getMarketRowText(
    { question: market.question, marketTitle: market.title, eventTitle },
    QUESTION_ORDER
  ).title;

export const getXShareSummary = (
  group: IMarket[],
  outcome: IOutcomeConsensus | null,
  selection: IXShareSelection,
  eventTitle: string
): IXShareSummary | null => {
  if (selection.marketId === null) {
    const [first] = group;

    if (!first) {
      return null;
    }

    return {
      question: getQuestion(first, eventTitle),
      chance: outcome?.chance ?? null,
      change24h: outcome?.chanceChange24h ?? null,
      platforms: uniquePlatforms(group),
      isConsensus: true,
    };
  }

  const market = group.find(({ id }) => id === selection.marketId);

  if (!market) {
    return null;
  }

  return {
    question: getQuestion(market, eventTitle),
    chance: market.chance,
    change24h: market.chanceChange24h,
    platforms: [market.platform],
    isConsensus: false,
  };
};
